<template>
  <div>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12 mg-top-1" v-if="power['添加']">
          <b-button variant="primary" @click="toCreate()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model.trim="pageParams.content"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <el-date-picker
              style="max-width: 350px"
              size="mini"
              v-model="daterange"
              clearable
              @change="updatedTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
            >
            </el-date-picker>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.state"
              class="form-select"
              :options="verifyStatus"
              type="text"
            ></b-form-select>
          </div>
          <b-button
            size="sm"
            v-if="power['添加']"
            variant="primary"
            @click="toCreate()"
          >
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive" v-loading="tableLoading">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 40px">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">问答名称</th>
                  <th scope="col">封面</th>
                  <th scope="col">媒体号</th>
                  <th scope="col">总分</th>
                  <th scope="col">题目数</th>
                  <th scope="col">答题人数</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建人/创建时间</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">
                    <div
                      style="cursor: pointer"
                      @click="showPre(item.shareUrl)"
                    >
                      {{ item.title }}
                    </div>
                  </td>
                  <td>
                    <img
                      v-if="item.cover"
                      class="w-16-9-rem"
                      :src="`${item.cover}`"
                      alt
                    />
                    <img
                      v-if="!item.cover"
                      class="w-16-9-rem"
                      src="@/assets/images/default_cover_16_9.png"
                      alt=""
                    />
                    <!-- <img
                      v-if="item.cover"
                      class="w-3-rem"
                      :src="`${item.cover}`"
                      alt
                    />
                    <img
                      v-if="!item.cover"
                      class="w-3-rem"
                      src="@/assets/images/default_cover_1_1.png"
                      alt=""
                    /> -->
                  </td>
                  <td>{{ item.bindMediaName || "--" }}</td>

                  <td class="w-300 white-inherit">{{ item.score }}</td>
                  <td>{{ item.questionNum }}</td>
                  <td>{{ item.finishedNum }}</td>
                  <td>
                    <el-tooltip
                      v-if="power['显示/隐藏']"
                      :content="item.state == 1 ? '点击禁用' : '点击启用'"
                    >
                      <span
                        @click="modifyStatus(item, '0')"
                        v-if="item.state == 1"
                        class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span
                        @click="modifyStatus(item, '1')"
                        v-if="item.state == 0"
                        class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </el-tooltip>
                    <div v-if="!power['显示/隐藏']">
                      <span v-if="item.state == 1" class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span v-if="item.state == 0" class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </div>
                  </td>

                  <td>
                    {{ item.creator || "--" }}<br />{{ item.createdAt || "--" }}
                  </td>
                  <td>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toTopic(item.id)"
                    >
                      题目
                    </button>
                    <button
                      v-if="power['成绩数据']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toPerformance(item)"
                    >
                      成绩数据
                    </button>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item.id)"
                    >
                      编辑
                    </button>
                    <el-popover
                      @show="showQRcode(item.shareUrl)"
                      placement="bottom"
                      title="分享二维码"
                      width="200"
                      trigger="hover"
                    >
                      <div>
                        <img :src="currentQRcode" />
                      </div>
                      <button
                        slot="reference"
                        v-if="power['查看']"
                        type="button"
                        class="btn-sm btn btn-primary m-r-10"
                        @click="copyUrl(item.shareUrl)"
                      >
                        复制预览链接
                      </button>
                    </el-popover>
                    <button
                      v-if="power['移除']"
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      移除
                    </button>
                    <!-- </td> -->
                  </td>

                  <!-- 草稿：编辑详情、提交审核、删除
                待审核：查看、撤销、删除；展示预览链接
                驳回：编辑详情、提交审核、驳回原因、删除
                审核通过后-->
                </tr>
              </tbody>
            </table>
            <div v-if="!items || !items[0]" class="xb-table-noData">
              <span v-if="!tableLoading && !items[0]">暂无数据</span>
            </div>
          </div>
          <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
          batchs 批量操作的列表
          pageCallback 分页组件的回调方法 -->
          <pagination
            class="bath_r_20"
            :total="pageTotal"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            @pageCallback="pageCallback"
            isBatch
            :batchs="batchs"
          ></pagination>
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      size="450px"
      :direction="direction"
      :show-close="false"
      :destroy-on-close="true"
    >
      <iframe
        style="height: 100%; width: 100%"
        ref="iframe"
        class="iframe-item"
        :src="rowData.previewUrl"
      ></iframe>
    </el-drawer>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import question from "@/server/api/question.js";
import DatePicker from "vue2-datepicker";
import { replaceImgUrl, changeList } from "@/util/fun.js";

/**
 * Contacts-list component
 */
export default {
  components: {
    DatePicker,
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      power: "",
      choiceListIds: [], //当前所选择的id
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        showState: "",
        timeType: "",
        state: "",
        content: "",
        deleted: false,
      },
      currentTag: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "移除", value: "3" },
      ],
      statusList: [
        { text: "显示状态", value: "" },
        { text: "显示", value: "1" },
        { text: "隐藏", value: "0" },
      ],
      verifyStatus: [
        { text: "筛选状态", value: "" },
        { text: "启用", value: "1" },
        { text: "禁用", value: "0" },
        // { text: "驳回", value: "2" },
        // { text: "待审核", value: "3" },
      ],
      effectStatus: [
        { text: "生效状态", value: "" },
        { text: "生效中", value: "1" },
        { text: "待生效", value: "2" },
        { text: "已失效", value: "3" },
      ],
      daterange: "",
      drawer: false,
      rowData: {},
      direction: "rtl",
      currentQRcode: "",
      pageTotal: 0,
      tableLoading: false,
      pageTotal: 0,
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.items.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  created() {
    if (this.$store.state.pageParams.questionList) {
      this.pageParams = {
        ...this.pageParams,
        ...this.$store.state.pageParams.questionList,
      };
      if (this.pageParams.startTime && this.pageParams.endTime) {
        this.daterange = [
          new Date(this.pageParams.startTime),
          new Date(this.pageParams.endTime),
        ];
      }
    }
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    this.power = this.utils.currentPower("创作平台-问卷管理");
    let obj = this.getCache("question-list");
    console.log("缓存的数据", obj);
    if (obj && obj.list && obj.list[0]) {
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      this.pageParams = obj.pageParams;
      this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
      obj = this.getCache("question-edit");
      console.log("编辑缓存", obj);
      if (obj) {
        if (obj.id) {
          question.detail({ id: obj.id }).then((res) => {
            this.addCache("question-edit", "");
            if (res.code === 0) {
              console.log("问答详情", res);
              let detail = res.data;
              detail.id = obj.id;
              delete detail.shareUrl; //详情的这个是空值，需要去掉
              this.items = this.items.map((tr) => {
                if (tr.id == detail.id) {
                  return { ...tr, ...detail };
                } else {
                  return tr;
                }
              });
            } else {
              this.getList(false);
            }
          });
        } else if (obj.changed) {
          this.getList(false);
          this.addCache("question-edit", "");
        }
      }
    } else {
      this.getList();
      this.addCache("question-edit", "");
    }
  },
  beforeDestroy() {
    this.$store.dispatch("pageParams/cacheQuestionListParams", this.pageParams);
    this.addCache("question-list", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },
  methods: {
    async showQRcode(url) {
      this.currentQRcode = await this.$qrCode.toDataURL(url);
    },
    copyUrl(data) {
      var input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", data);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      Vue.swal({
        icon: "success",
        title: "复制链接成功",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    showPre(url) {
      this.rowData.previewUrl = url + "&backend=true";
      this.drawer = true;
    },
    //获取列表数据
    getList(showLoading) {
      let oldList = this.items;
      let params = this.utils.getQuery(this.pageParams);
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      question.list(params).then((resp) => {
        if (resp.code == 0 && resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = replaceImgUrl(resp.data.items, oldList);
            this.pageTotal = resp.data.total;
            this.updateCache("question-list", {
              list: this.items,
              pageTotal: this.pageTotal,
            });
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "pageSize") {
        //更改页码
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }

      if (obj.code === "batch") {
        //处理批量操作
        if (obj.batch == "3") {
          if (this.choiceListIds.length) {
            //点击通过的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },
    //添加
    toCreate() {
      this.$router.push({
        name: "questionAdd",
      });
    },
    //去题目
    toTopic(id) {
      this.$router.push({
        name: "questionTopic",
        query: { id: id },
      });
    },
    //去成绩数据
    toPerformance(item) {
      this.$router.push({
        name: "performance",
        query: { id: item.id },
      });
    },
    //去编辑
    toDetail(id) {
      this.$router.push({
        name: "questionAdd",
        query: { id: id },
      });
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      if (this.daterange) {
        this.pageParams.startTime = this.daterange[0].format(
          "yyyy-MM-dd hh:mm:ss"
        );
        this.pageParams.endTime = this.daterange[1].format(
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.content = "";
      this.pageParams.state = "";
      this.daterange = "";
      delete this.pageParams.startTime;
      delete this.pageParams.endTime;
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.items.map((item) => item.id);
      } else {
        this.choiceListIds = [];
      }
    },
    //修改 启用 禁用状态
    modifyStatus(item, status) {
      let title_text = status == 1 ? "确定启用？" : "确定禁用？";
      Swal.fire({
        title: title_text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {
            id: item.id,
            title: item.title, //标题
            cover: item.cover, //封面
            time: item.time, //答题时间
            startTime: item.startTime, //开始时间
            endTime: item.endTime, //结束时间
            allowCount: item.allowCount, //允许答题次数
            openVerify: item.openVerify,
            state: Number(status), //0-禁用,1-启用
          };
          question.base(params).then((resp) => {
            if (resp.code == 0) {
              let success_text = status == 1 ? "显示成功" : "隐藏成功";
              Vue.swal({
                icon: "success",
                title: success_text,
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList();
              item.state = Number(status);
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
    //删除
    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = [];
          if (item) {
            // params.ids = [];
            // params.ids.push(item.id);
            params.push(item.id);
          } else {
            params = this.choiceListIds;
          }
          question.remove(params).then((resp) => {
            if (resp.code == 0) {
              //删除成功时清空回收站缓存以刷新列表
              this.updateCache("question-recycle-list", { list: "" });
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.length) {
                this.getList();
              } else {
                this.pageTotal -= params.length;
                this.items = changeList("delete", this.items, params, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
    //更改时间
    updatedTime(val) {
      if (!val) {
        this.pageParams.startTime = "";
        this.pageParams.endTime = "";
      }
    },
  },
};
</script>

<style></style>
<style scoped>
::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
